<template>
  <div class="sidenavright-menu fullheight">
    <div class="sidenavright-content" v-click-outside="closeMenu">
        <div class="pill-header">
          <div class="row no-margin">
            <div class="col no-padding">
              <div class="pill-title">
                {{ this.rejectedTrip.shipmentNumber }}
              </div>
            </div>
            <div class="col-md-auto no-padding bgclose">
              <div class="close-sidebar">
                <svgicon name="cancelwhite" width="14" height="14"
                :original="true" @click="closeMenu" />
              </div>
            </div>
          </div>
        </div>
        <div class="pill-body">
        <div class="pill-row tabsection">
        <Tabs>
          <Tab title="INVALID FIELDS" :active="true">
            <div class="tab-body" v-if="rejectedTrip">
              <div v-for="(row,index) in rejectedTrip.invalidFields" :key="index">
                <div class="pill-primarytext text-red mb-8">
                  <strong>{{row.field}} :</strong>
                </div>
                <div class="pill-sectext mb-15">
                  <span>{{row.message}}</span>
                </div>
              </div>
            </div>
          </Tab>
        </Tabs>
      </div>
    </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  props: {
    rejectedTrip: {
      type: Object,
      required: true,
    },
  },
  computed: {
    showInvalidFields() {
      return this.rejectedTrip.invalidFields;
    },
  },
  methods: {
    closeMenu() {
      this.$emit('close');
    },
  },
};
</script>
